import { useEffect, useState } from "react";

import * as S from "./styles";

import { Tab } from "../../../TabHeader";
import { StepModalTemplate } from "templates/StepModalTemplate";
import { IUser } from "interfaces/User";
import { UserForm } from "../../../Forms/User/UserForm";
import { useUserRegister } from "contexts/register/UserContext";
import { ScheduleForm } from "../../../Forms/User/ScheduleForm";
import {
  handleUserUpdateSubmit,
  handleUserRegisterSubmit,
} from "services/handles/UserHandles";
import { IExpressValidatorError } from "interfaces/ExpressError";
import { transformValidatorError } from "utils/transformValidatorError";

type Props = {
  opened: boolean;
  setOpened: (value: boolean) => void;
  userData?: IUser;
};

const tabs: Tab[] = [
  { index: 0, text: "Dados de Usuário" },
  { index: 1, text: "Expediente" },
];

export function StepRegisterUser({ opened, setOpened, userData }: Props) {
  const {
    setErrors,
    retrieveUser,
    resetUser,
    schedule,
    user,
    searching,
    errors,
    removeError,
  } = useUserRegister();

  const [tab, setTab] = useState<Tab>(tabs[0]);

  const [invalidTabs, setInvalidTabs] = useState<Tab[]>([]);

  const [deactivatedTabs, setDeactivatedTabs] = useState<Tab[]>([]);
  const [role, setRole] = useState("");

  const [sending, setSending] = useState<boolean>(false);

  useEffect(() => {
    return () => {
      localStorage.removeItem("mondayEntry");
      localStorage.removeItem("mondayExit");
      localStorage.removeItem("tuesdayEntry");
      localStorage.removeItem("tuesdayExit");
      localStorage.removeItem("wednesdayEntry");
      localStorage.removeItem("wednesdayExit");
      localStorage.removeItem("thursdayEntry");
      localStorage.removeItem("thursdayExit");
      localStorage.removeItem("fridayEntry");
      localStorage.removeItem("fridayExit");
      localStorage.removeItem("saturdayEntry");
      localStorage.removeItem("saturdayExit");
      localStorage.removeItem("sundayEntry");
      localStorage.removeItem("sundayExit");
    };
  }, []);

  useEffect(() => {
    if (
      role === "6048f43b-e92d-4414-9443-ef735ef0033a" ||
      user.role === "6048f43b-e92d-4414-9443-ef735ef0033a"
    ) {
      setTab(tabs[0]);
      return setDeactivatedTabs((list) => [...list, tabs[1]]);
    }
    setDeactivatedTabs([]);
  }, [role, user]);

  useEffect(() => {
    setInvalidTabs([]);
    if (userData) {
      setErrors({});
      retrieveUser(userData.id);
      return;
    }

    resetUser();
  }, [userData]); // eslint-disable-line react-hooks/exhaustive-deps

  function setTabAsInvalid(tab: Tab) {
    setInvalidTabs((value) => [...value, tab]);
  }
  function treatDuplicatedValidator(data: {
    [key: string]: { message: string };
  }) {
    let response: any = {};
    for (const key in data) {
      if (key.includes("cpf") || key.includes("rg")) setTabAsInvalid(tabs[0]);
      response[key] = data[key].message;
    }
    setErrors((err) => {
      return { ...err, ...response };
    });
  }
  function treatValidatorErrors(validatorErrors: IExpressValidatorError) {
    setInvalidTabs([]);

    if (validatorErrors === undefined) return;

    const { errors, invalidFormTypes } =
      transformValidatorError(validatorErrors);

    for (const type of invalidFormTypes) {
      if (type.includes("user")) setTabAsInvalid(tabs[0]);
    }

    setErrors(errors);
  }

  useEffect(() => {
    if (Object.keys(errors).length === 0) {
      setInvalidTabs([]);
    }
  }, [errors]);

  async function handleSubmit() {
    setSending(true);
    if (userData) {
      return await handleUserUpdateSubmit({
        userId: userData.id,
        cpf: user.cpf,
        email: user.email,
        name: user.name,
        rg: user.rg,
        role: user.role,
        type: user.type,
        scheduleId: schedule.id,
        mondayEntry: schedule.mondayEntry,
        mondayExit: schedule.mondayExit,
        tuesdayEntry: schedule.tuesdayEntry,
        tuesdayExit: schedule.tuesdayExit,
        wednesdayEntry: schedule.wednesdayEntry,
        wednesdayExit: schedule.wednesdayExit,
        thursdayEntry: schedule.thursdayEntry,
        thursdayExit: schedule.thursdayExit,
        fridayEntry: schedule.fridayEntry,
        fridayExit: schedule.fridayExit,
        saturdayEntry: schedule.saturdayEntry,
        saturdayExit: schedule.saturdayExit,
        sundayEntry: schedule.sundayEntry,
        sundayExit: schedule.sundayExit,
      })
        .then((res) => {
          if (res.status === true) {
            resetUser();

            localStorage.setItem(
              "message",
              "Os dados do Usuário foram salvos corretamente."
            );

            window.location.reload();
            return;
          }
          if (res.data.duplicated) {
            treatDuplicatedValidator(res.data.error);
          } else {
            treatValidatorErrors(res.data.error);
          }
        })
        .catch((error) => {
          treatValidatorErrors(error.data);
        })
        .finally(() => {
          setSending(false);
        });
    }
    return await handleUserRegisterSubmit({
      password: user.password,
      cpf: user.cpf,
      email: user.email,
      name: user.name,
      rg: user.rg,
      role: user.role,
      mondayEntry: schedule.mondayEntry,
      mondayExit: schedule.mondayExit,
      tuesdayEntry: schedule.tuesdayEntry,
      tuesdayExit: schedule.tuesdayExit,
      wednesdayEntry: schedule.wednesdayEntry,
      wednesdayExit: schedule.wednesdayExit,
      thursdayEntry: schedule.thursdayEntry,
      thursdayExit: schedule.thursdayExit,
      fridayEntry: schedule.fridayEntry,
      fridayExit: schedule.fridayExit,
      saturdayEntry: schedule.saturdayEntry,
      saturdayExit: schedule.saturdayExit,
      sundayEntry: schedule.sundayEntry,
      sundayExit: schedule.sundayExit,
      schedule: !(
        role === "6048f43b-e92d-4414-9443-ef735ef0033a" ||
        user.role === "6048f43b-e92d-4414-9443-ef735ef0033a"
      ),
    })
      .then((res) => {
        if (res.status === true) {
          resetUser();

          localStorage.setItem(
            "message",
            "Os dados do Usuário foram cadastrados corretamente."
          );

          window.location.reload();
          return;
        }

        if (res.data.duplicated) {
          treatDuplicatedValidator(res.data.error);
        } else {
          treatValidatorErrors(res.data.error);
        }
      })
      .catch((error) => {
        treatValidatorErrors(error.data);
      })
      .finally(() => {
        setSending(false);
      });
  }

  function onTabClick(_tab: Tab) {
    setTab(_tab);
  }

  return (
    <StepModalTemplate
      deactivatedTabs={deactivatedTabs}
      opened={opened}
      disableButton={Object.keys(errors).length > 0}
      setOpened={setOpened}
      buttonText={userData ? "Salvar edição" : "Efetuar cadastro"}
      handleSubmit={handleSubmit}
      tabs={tabs}
      setSelectedTab={onTabClick}
      selectedTab={tab}
      sending={sending}
      title={`${userData ? "Editar" : "Cadastrar"} Usuário`}
      invalidTabs={invalidTabs}
    >
      <S.Container>
        {searching && (
          <S.LoadingWrapper>
            <span>Buscando dados do Usúario...</span>
          </S.LoadingWrapper>
        )}

        {!searching && (
          <div>
            {tab.index === 0 && (
              <UserForm setRole={setRole} isEditing={userData !== undefined} />
            )}
            {tab.index === 1 && (
              <ScheduleForm isEditing={userData !== undefined} />
            )}
          </div>
        )}
      </S.Container>
    </StepModalTemplate>
  );
}
